import {formatCurrency} from "@lib/format";

export function deltaColor(delta: number, invert = false): string {
    if (delta === 0) return "text-[#64748b]";
    const positive = invert ? delta < 0 : delta > 0;
    return positive ? "text-green-600" : "text-red-500";
}

export function parseNumericValue(value: string | number | null | undefined): number | null {
    if (value === null || value === undefined) return null;
    if (typeof value === "number") return Number.isFinite(value) ? value : null;

    const raw = value.trim();
    if (!raw || raw === "-" || raw.toLowerCase() === "n/a") return null;

    let cleaned = raw;
    let negate = false;

    if (cleaned.startsWith("(") && cleaned.endsWith(")")) {
        negate = true;
        cleaned = cleaned.slice(1, -1);
    }

    cleaned = cleaned.replace(/[$,%\s]/g, "").replace(/,/g, "");

    let multiplier = 1;
    const suffix = cleaned.slice(-1).toLowerCase();
    if (suffix === "k" || suffix === "m" || suffix === "b") {
        cleaned = cleaned.slice(0, -1);
        if (suffix === "k") multiplier = 1_000;
        if (suffix === "m") multiplier = 1_000_000;
        if (suffix === "b") multiplier = 1_000_000_000;
    }

    const parsed = Number(cleaned);
    if (!Number.isFinite(parsed)) return null;
    const n = parsed * multiplier;
    return negate ? -n : n;
}

export function formatDelta(value: string | number): string {
    const n = parseNumericValue(value);
    if (n === null) return String(value);
    if (n === 0) return "-";
    const sign = n > 0 ? "+" : "";
    return sign + formatCurrency(n, true);
}

export function highlightClass(highlight?: "positive" | "negative" | "neutral"): string {
    switch (highlight) {
        case "positive":
            return "text-green-600";
        case "negative":
            return "text-red-500";
        case "neutral":
            return "text-[#64748b]";
        default:
            return "";
    }
}

export function statusToVariant(status: string): "secondary" | "outline" | "destructive" {
    const s = status.toUpperCase();
    if (s === "PASS" || s === "DONE" || s === "SUCCESS") return "secondary";
    if (s === "WARN" || s === "WARNING" || s === "PENDING") return "outline";
    return "destructive";
}

export function statusToBadgeClasses(status: string): string {
    const s = status.toUpperCase();
    if (s === "PASS" || s === "DONE" || s === "SUCCESS") return "bg-green-100 text-green-800";
    if (s === "WARN" || s === "WARNING" || s === "PENDING") return "border-amber-300 text-amber-700";
    return "";
}
